import {
  useChargeVerificationPermission,
  useSrChargeVerificationEnabled,
} from 'react-hooks';

export function useVerifyAndSubmitBilling(channelId?: string) {
  const isVerifyFlowEnabled = useSrChargeVerificationEnabled();
  const canVerifyAndSubmit = useChargeVerificationPermission(channelId ?? '');

  return { isVerifyFlowEnabled, canVerifyAndSubmit };
}
